export default "__VITE_ASSET__DnQJM84Q__"